import { Injectable } from '@angular/core';
import { AppUser, IAppUser } from '../models/app-user.model';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public loading: boolean = false;
  public users: AppUser[] = [];

  constructor(
    public authService: AuthService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) { 
    this.getAll();
  }

  /*
   ██████╗ ███████╗████████╗ █████╗ ██╗     ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██║     ██║
  ██║  ███╗█████╗     ██║   ███████║██║     ██║
  ██║   ██║██╔══╝     ██║   ██╔══██║██║     ██║
  ╚██████╔╝███████╗   ██║   ██║  ██║███████╗███████╗
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚══════╝

  */
  /**
   * FUNCTION getAll
   */
  async getAll() {
    this.loading = true;

    const urlApi = `${environment.urlAPI}/users`;

    try {

      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse<{ users: IAppUser[] }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ users: IAppUser[] }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ users: IAppUser[] }>
              ) => resolve(
                new ServerResponse<{ users: IAppUser[] }>(response)
              ),
            error: (error) => {

              this.toastService.show(
                {
                  header: 'Error en el servidor',
                  body: `${error}`
                }
              )

              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error en el servidor',
                    body: `${error}`
                  }
                );
              }
            },
          });
        }
      );

      if(response.statusCode === 200) {
        this.users = response.data!.users.map(
          (user) => new AppUser(user)
        );
      }

    } catch(error) {
      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`
        }
      );
    }

    this.loading = false;
  }

}
